"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPresentationUsingShortLabelAsChoiceValue = exports.isPresentationUsingMinValueAsChoiceValue = exports.isPresentationUsingEmptyAsChoiceValue = exports.isPresentationUsingDefaultMinAndMaxValues = exports.isPresentationStartingWithNullValue = exports.isPresentationSelectingFirstChoiceAsDefault = void 0;
var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));
var _toLower = _interopRequireDefault(require("lodash/toLower"));
var _settings = require("../settings");
/* eslint-disable quote-props */

var defaults = {
  presentationsUsingShortLabelAsChoiceValue: {
    'default': true,
    'color': true,
    'colorwprice': true,
    'headrail': true,
    'standard': true,
    'childsafetywarning': true,
    'surefit': true,
    'mount': true,
    'roomselector': true,
    'dropdown': true,
    'dropdownwithprice': true,
    'threecolumncontrol': true,
    'twocolumncontrol': true,
    'remake': true,
    'shape': true,
    'trim': true
  },
  presentationsUsingEmptyAsChoiceValue: {
    'textbox': true,
    'textentryrequired': true,
    'textentry': true,
    'opentextbox': true,
    'windowname': true
  },
  presentationsUsingMinValueAsChoiceValue: {
    'width': true,
    'height': true,
    'length': true,
    'customsize': true,
    'dimension': true,
    'numberrangedropdown': true,
    'fromzerotoahundredmeasurement': true
  },
  presentationsStartingWithNull: {
    'threecolumnmeasurement': true,
    'twocolumnmeasurement': true
  },
  presentationsUsingDefaultMinAndMaxValues: {},
  presentationsSelectingFirstChoiceAsDefault: {
    'standard': true,
    'dropdown': true,
    'dropdownwithprice': true,
    'tileanddropdown': true,
    'numberrangedropdown': true,
    'threecolumnmeasurement': true,
    'twocolumnmeasurement': true,
    'threecolumncontrol': true,
    'twocolumncontrol': true,
    'binding': true,
    'shape': true
  }
};
var buildList = function buildList(listName) {
  var defaultList = defaults[listName];
  var getCustoms = (0, _settings.getSettings)()[listName];
  return getCustoms ? (0, _mapKeys["default"])(getCustoms(defaultList), function (val, key) {
    return (0, _toLower["default"])(key);
  }) : defaultList;
};
var presentationNameLookup = function presentationNameLookup(listName) {
  return function (presentationName) {
    var presentations = buildList(listName);
    var name = (0, _toLower["default"])(presentationName);
    return Boolean(presentations[name]);
  };
};
var isPresentationUsingShortLabelAsChoiceValue = exports.isPresentationUsingShortLabelAsChoiceValue = presentationNameLookup('presentationsUsingShortLabelAsChoiceValue');
var isPresentationUsingEmptyAsChoiceValue = exports.isPresentationUsingEmptyAsChoiceValue = presentationNameLookup('presentationsUsingEmptyAsChoiceValue');
var isPresentationUsingMinValueAsChoiceValue = exports.isPresentationUsingMinValueAsChoiceValue = presentationNameLookup('presentationsUsingMinValueAsChoiceValue');
var isPresentationUsingDefaultMinAndMaxValues = exports.isPresentationUsingDefaultMinAndMaxValues = presentationNameLookup('presentationsUsingDefaultMinAndMaxValues');
var isPresentationSelectingFirstChoiceAsDefault = exports.isPresentationSelectingFirstChoiceAsDefault = presentationNameLookup('presentationsSelectingFirstChoiceAsDefault');
var isPresentationStartingWithNullValue = exports.isPresentationStartingWithNullValue = presentationNameLookup('presentationsStartingWithNull');
//# sourceMappingURL=presentations.js.map